<template>
  <v-window :value="currentPage" class="app-max-width">
    <v-window-item value="question" :class="{'content-covered':timeReached}">
      <v-alert v-if="timeReached" class="text-center">{{ $t('general.timer.time_reached') }}</v-alert>
      <QuestionContentRenderer :question="question"></QuestionContentRenderer>
    </v-window-item>
    <v-window-item value="answer" eager>
      <v-alert v-if="timeReached" class="text-center">{{ $t('general.timer.time_reached') }}</v-alert>
      <v-content v-if="hasAnyHeaderContent" :class="{'content-covered':timeReached}">
        <v-row>
          <v-col class="align-center">
            <span v-if="question.header_textassetid">{{$ta(question.header_textassetid)}}</span>
            <h3 v-if="question.item_textassetid">{{$ta(question.item_textassetid)}}</h3>
            <small v-if="question.subtitle_textassetid">{{$ta(question.subtitle_textassetid)}}</small>
          </v-col>
        </v-row>
      </v-content>
      <QuestionresponseRenderer
          :class="{'content-covered':timeReached}"
          v-if="journeyresponse.questionresponse.response_type != 'rank' || currentPage == 'answer'"
          :journeyresponse="journeyresponse" @next="next()" @complete="emitComplete($event)"
          :visible="currentPage==='answer'" @time-reached="timeReached=true"></QuestionresponseRenderer>
    </v-window-item>
  </v-window>
</template>

<script>
import questionLayoutMixin from "./questionLayoutMixin";
import applicationEventHub from "../../../../events/applicationEventHub";

export default {
  name: "StepQuestionLayout",
  mixins: [questionLayoutMixin],
  computed: {
    hasAnyHeaderContent() {
      return this.question && (this.question.header_textassetid || this.question.subtitle_textassetid || this.question.item_textassetid);
    }
  },
  data() {
    return {
      currentPage: 'question',
      timeReached : false
    }
  },
  created() {

  },
  mounted() {
    this.clearBindings();
    this.bindQuestionPageEvents();
  },
  methods: {
    clearBindings() {
      applicationEventHub.$off('framework.back', this.backToQuestion);
      applicationEventHub.$off('framework.next', this.next);
      applicationEventHub.$off('framework.back', this.back);
      applicationEventHub.$off('framework.next', this.nextToAnswer);
    },
    bindQuestionPageEvents() {
      applicationEventHub.$on('framework.back', this.back);
      applicationEventHub.$on('framework.next', this.nextToAnswer);
    },
    bindAnswerPageEvents() {
      applicationEventHub.$on('framework.back', this.backToQuestion);
      applicationEventHub.$on('framework.next', this.next);
    },
    nextToAnswer() {
      this.clearBindings();
      this.bindAnswerPageEvents();
      this.currentPage = 'answer';
      applicationEventHub.stopMedia();
    },
    backToQuestion() {
      this.clearBindings();
      this.bindQuestionPageEvents();
      this.currentPage = 'question';
    }
  },
  beforeDestroy() {
    this.clearBindings();
  }
}
</script>

<style scoped>
.align-center {
  text-align: center;
}
</style>